import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class LightboxGallery {
	constructor() {
		this.lightboxBlock = $('.lightbox-gallery');
		this.lightboxes = $(
			'.lightbox-gallery [class^="gallery-slider__slider"]'
		);
		this.lightboxOpen = $('.lightbox-gallery__single-thumb');
		this.lightboxClose = $('.lightbox-gallery__close');
		this.lightboxWrapper = this.lightboxBlock.find(
			'.lightbox-gallery__gallery-wrapper'
		);
	}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		this.lightboxOpen.on('click', this.openLightbox);
		this.lightboxClose.on('click', this.closeLightbox.bind(this));
	}
	openLightbox(e) {
		e.preventDefault();
		const slideNum = parseInt(this.hash.slice(1), 10);
		const lightboxBlock = $(this).closest('.lightbox-gallery');

		lightboxBlock
			.find('.lightbox-gallery__gallery-wrapper')
			.addClass('active');
		lightboxBlock
			.find('.gallery-slider-s')
			.slick('slickGoTo', slideNum, true);
		lockScroll.lock();
	}
	refreshSlider() {
		this.lightboxes.slick('refresh');
	}
	closeLightbox() {
		this.lightboxWrapper.removeClass('active');
		lockScroll.unlock();
	}
	keyDown(e) {
		if (e.keyCode === 27 && this.lightboxWrapper.hasClass('active')) {
			this.closeLightbox();
		}
	}
}
export default new LightboxGallery();
